import { hideSpinner, showSpinner } from 'app/modules/cms/service/store/cms-dispatchs';
import { loungeApi } from '../api/lounge-api';
import { LoungeActionConstants } from '../utils/lounge-action-constant';

export const getUrlLounge = (subscriptionNumber: string, claimNumber: string, action: LoungeActionConstants) => {
  try {
    return loungeApi.getUrlLounge(subscriptionNumber, claimNumber, action);
  } catch (err) {
    console.log('call to service/getUrlLounge ===>', err);
  }
};

export const redirectToLounge = (action: LoungeActionConstants) => async (dispatch, getState) => {
  console.log('redirectToLounge service');
  const { subscription } = getState().kubrickManagement;
  const { claimNumber } = getState().claim;
  dispatch(showSpinner());
  const response = await getUrlLounge(subscription?.subscriptionNumber || '', claimNumber, action);
  if (response) {
    window.location.href = response.data;
  }
  dispatch(hideSpinner());
};
